// 推薦服務搭配設定（CNCY-10772）

// 服務類型；選擇表先顯示服務項目，再顯示附加服務
export const appointmentServicePairingServiceTypeConfig = {
  service: { label: '服務項目', value: 'service' },
  serviceAttach: { label: '附加服務', value: 'serviceAttach' },
}

// 每組最多幾個搭配服務
export const appointmentServicePairingMaxItems = 10
